import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { workspaceReady, switchWorkspace } from '../utils/workspace';

// Workspace section of the header settings dropdown (#profile-workspaces in
// public/html/*-top.html, on every page): the workspaces the user is in —
// sysAdmins: Admin plus every workspace — as a dropdown on the current
// one (just its name when there's only one). Picking another switches to it
// (utils/workspace.js) and opens its Dashboard. Not shown on share links or while logged out.
//
// The header HTML is injected (and the dropdown moved onto <body>) after
// React renders, so the placeholder is looked up whenever the DOM changes.

const selectStyle = {
  width: '100%', height: 34, boxSizing: 'border-box', padding: '0 30px 0 10px',
  border: '1px solid #ddd', borderRadius: 7, background: '#fff', color: '#1a1a1a',
  fontSize: 13, fontFamily: 'Inter, Arial, sans-serif', cursor: 'pointer',
  appearance: 'none', WebkitAppearance: 'none',
  // Chevron (the native one is hidden for a consistent look).
  backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")",
  backgroundRepeat: 'no-repeat', backgroundPosition: 'right 10px center',
};

const WorkspaceMenu = () => {
  const [host, setHost] = useState(null);
  const [state, setState] = useState(null); // { workspaceId, workspaces }

  useEffect(() => {
    workspaceReady().then(setState);
    const onReady = (e) => setState(e.detail);
    window.addEventListener('workspaceReady', onReady);
    return () => window.removeEventListener('workspaceReady', onReady);
  }, []);

  useEffect(() => {
    const find = () => setHost((prev) => {
      const el = document.getElementById('profile-workspaces');
      return el === prev ? prev : el;
    });
    find();
    const observer = new MutationObserver(find);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  if (!host || !state || !state.workspaces.length) return null;
  const many = state.workspaces.length > 1;

  // A dropdown, so the menu stays compact however many workspaces there are.
  return createPortal(
    <>
      <div className="profile-dropdown-section" style={{ paddingBottom: 12 }}>
        <label htmlFor="profile-workspace-select" style={{ display: 'block', fontSize: 10, fontWeight: 600, color: '#999', textTransform: 'uppercase', letterSpacing: '0.05em', padding: '0 2px 6px' }}>
          Workspace
        </label>
        {many ? (
          <select
            id="profile-workspace-select"
            value={state.workspaceId || ''}
            onChange={(e) => switchWorkspace(e.target.value)}
            style={selectStyle}
          >
            {state.workspaces.map((w) => (
              <option key={w.workspaceId} value={w.workspaceId}>{w.name}</option>
            ))}
          </select>
        ) : (
          <span style={{ display: 'block', fontSize: 13, color: '#1a1a1a', fontFamily: 'Inter, Arial, sans-serif', padding: '0 2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {state.workspaces[0].name}
          </span>
        )}
      </div>
      <div className="profile-dropdown-divider" />
    </>,
    host,
  );
};

export default WorkspaceMenu;
